
<div *ngIf="report != null">
  <div *ngIf="showTitle && report.DisplayName" style="padding: 7px 7px 7px 7px;">
    <div style="font-size: 20px; font-weight: bold; white-space: nowrap;">
      {{report.Name}}
    </div>
    <span style="font-size: 13px; font-style: italic; white-space: nowrap;">{{report.Description != null ? report.Description : ''}}</span>
  </div>

  <table style="width: 100%;">
    <tbody>
      <tr *ngFor="let r of rows">
        <td *ngFor="let c of r" style="padding: 15px 15px 15px 15px;" [style.width]="(100.0 / report.ColumnCount).toString() + '%'">
          <div>
            <div *ngIf="c != null" class="mat-elevation-z5 " [ngClass]="{'clickable darkenOnHover' : !report.ReportReportElements[c].MissingConfiguration}" (click)="showDetails(report.ReportReportElements[c])">
              <div style="padding: 10px 10px 10px 10px; ">
                <app-custom-report2-element [reportReportElement]="report.ReportReportElements[c]" [data]="reportData[report.ReportReportElements[c].ReportReportElementId]">

                </app-custom-report2-element>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
